/*
 * @Author: haozheng.whz
 * @Date: 2019-12-12 00:00:00
 * @LastEditors: haozheng.whz
 * @LastEditTime: 2019-12-12 00:00:00
 * @Description: JS Error插件
 */
import libs from './libs';
import sendApi from './libs/sendLog';
import AES from '@ali/aes-tracker';

(function () {
  if (window.__AES_PLUGIN_API__) return;
  window.__AES_PLUGIN_API__ = true;

  var _ref = AES.getConfig('plugin_api') || {},
      disableHook = _ref.disableHook,
      disableHookFetch = _ref.disableHookFetch,
      disableHookXHR = _ref.disableHookXHR,
      disableHookMtop = _ref.disableHookMtop;

  if (disableHook !== true) {
    var hookFetch = libs.hookFetch,
        hookXHR = libs.hookXHR,
        hookMtop = libs.hookMtop;
    disableHookFetch !== true && hookFetch();
    disableHookXHR !== true && hookXHR();
    disableHookMtop !== true && hookMtop();
  }
})();

export { sendApi };
export default {
  sendApi: sendApi
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/index.js
// module id = null
// module chunks = 